import DefaultBlock from "../components/main/DefaultBlock";
import { Typography, Box } from "@mui/material";
import ExperienceCard from "../components/experience/ExperienceCard";
import BlueprintBlock from "../components/main/BlueprintBlock";
import SEO from "../components/misc/SEO";

const experienceData = [
  {
    logoSrc: "/companies/gb.png",
    company: "Gadgetbot Inc",
    subtitle: "Kaidro: Clan Battles",
    link: "https://kaidro.com/",
    time: "2023-2025",
    points: [
      "Collaborated with UI/UX team to build high quality mobile user interfaces based on Figma designs",
      "Collaborated with gameplay programming team to create features using the Gameplay Ability System",
      "Worked closely with backend AWS team to integrate APIs for cloud storage",
    ],
  },
  {
    logoSrc: "/companies/mob.svg",
    company: "MOB Entertainment",
    subtitle: "Project: Playtime",
    link: "https://www.mobentertainment.com/poppy-playtime",
    time: "2021-2023",
    points: [
      "Developed the core infrastructure for multiplayer title Project: Playtime",
      "Integrated proprietary backend web API using C++",
      "Built deployment pipeline using Jenkins CI and batch",
      "Integrated Steam SDK for in-app purchases",
    ],
  },
  {
    logoSrc: "/companies/osg.svg",
    company: "Oversight Games",
    subtitle: "Civil: The Game",
    link: "https://oversightgames.com/p/civil",
    time: "2018-2021",
    points: [
      "Designed combat and vehicle mechanics",
      "Led design of vertical progression system",
      "Helped to program extensive netcode",
    ],
  },
];

export default function Experience() {
  return (
    <div>
      <SEO
        title="Experience | Aaron Hunt"
        description="Learn more about my work experience as a gameplay programmer, frontend developer, and UI/UX designer."
      />
      <BlueprintBlock text="export default function Experience() {" />
      <DefaultBlock id="work-examples">
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Work Experience
        </Typography>
        <Box className="backgroundGrid" sx={{ p: 2 }}>
          {experienceData.map((exp, index) => (
            <Box sx={{ mb: 2 }}>
              <ExperienceCard
                key={index}
                logoSrc={exp.logoSrc}
                company={exp.company}
                subtitle={exp.subtitle}
                link={exp.link}
                time={exp.time}
                points={exp.points}
              />
            </Box>
          ))}
        </Box>
      </DefaultBlock>
    </div>
  );
}
